import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import * as en from '../../../assets/i18n/en.json';

interface Translations {
    [key: string]: string;
}

@Pipe({
    name: 'translateValue',
    standalone: true,
})
export class TranslateValuePipe extends TranslatePipe implements PipeTransform {
    constructor(
        private translateService: TranslateService,
        ref: ChangeDetectorRef
    ) {
        super(translateService, ref);
    }

    override transform(value: any, args?: any): any {
        let modifiedValue = value;
        let result;
        const keysGeneral = Object.keys(en.general);
        const keysMessages = Object.keys(en.messages);

        if((value ?? ' ').toString().toLowerCase() === 'veneers') {
            modifiedValue = 'general.veneers';
            return super.transform(modifiedValue);
        } else if((value ?? ' ').toString().toLowerCase().includes('veneers')) {
            modifiedValue = 'general.veneers';
            return value.replace(/veneers/gi, this.translateService.instant(modifiedValue));
        }
        result = keysGeneral.find(key =>
            typeof (en.messages as any as Translations)?.[key] === 'string'
                ? (en.general as Translations)?.[key]?.toLowerCase() === (value ?? '').toString().toLowerCase()
                : false
        );

        if (result !== undefined) {
            modifiedValue = 'general.' + result;
        } else {
            result = keysMessages.find(key =>
                typeof (en.messages as any as Translations)?.[key] === 'string'
                    ? (en.messages as any as Translations)?.[key]?.toLowerCase() ===
                      (value ?? '').toString().toLowerCase()
                    : false
            );
            if (result !== undefined) {
                modifiedValue = 'messages.' + result;
            }
        }

        return super.transform(modifiedValue);
    }
}
